import { render } from "./Technical.vue?vue&type=template&id=3c226ef0&scoped=true"
import script from "./Technical.vue?vue&type=script&lang=ts"
export * from "./Technical.vue?vue&type=script&lang=ts"

import "./Technical.vue?vue&type=style&index=0&id=3c226ef0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c226ef0"

export default script